import { useState } from 'react';
import { Form, Card, Col, Container, Row } from 'react-bootstrap';
import { ControlButtons } from '../ControlButtons';

export function HazmatType({
	currHazType = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) {
	const [selectedHazType, setSelectedHazType] = useState(currHazType);

	const hazmatPermitTypes = {
        Prod: { Name: 'Production/Processing', Cost: 155 },
        Disp: { Name: 'Dispensing/Use', Cost: 115 },
        Stor: { Name: 'Storage', Cost: 80 },
        Waste: { Name: 'Waste Production', Cost: 30 },
        MinStor: { Name: 'Minimal Storage', Cost: 20 },
    };

	const hazMatLabel = '(Hazardous Materials)';

	const handleTypeChange = e =>
		setSelectedHazType({ ...selectedHazType, newOrRenew: e.target.value });

	const handleOptionChange = (selection) => {
        selectedHazType.type.includes(selection)
            ? selectedHazType.type.splice(selectedHazType.type.indexOf(selection), 1)
            : selectedHazType.type.push(selection);
        setSelectedHazType({
            ...selectedHazType,
            type: selectedHazType.type,
        });
    };

	const checkFieldsValid = () =>
		selectedHazType.type === '' || !selectedHazType.newOrRenew ? true : false;

	return (
		<>
			<Container className="component mt-5">
				<h2 className="mb-4">Select Permit Type</h2>
				<Row className="mt-4">
					<Col md={12}>
						<hr
							className=""
							style={{ backgroundColor: '#0074d9', width: '18rem' }}
						/>

						<Form>
							<Form.Check
								checked={selectedHazType.newOrRenew === 'new' ? true : false}
								type="radio"
								id="new-application"
								name="application_type"
								label="New Application"
								className="d-inline-flex ml-3 mr-4"
								onChange={handleTypeChange}
								value="new"
							/>
							<Form.Check
								checked={selectedHazType.newOrRenew === 'renew' ? true : false}
								type="radio"
								id="renewal-application"
								name="application_type"
								label="Renewal"
								className="d-inline-flex"
								onChange={handleTypeChange}
								value="renew"
							/>
						</Form>
						<hr
							className=""
							style={{ backgroundColor: '#0074d9', width: '18rem' }}
						/>
					</Col>
				</Row>

				<Row className="mt-4">
                    {Object.keys(hazmatPermitTypes).map((type) => (
                        <Col key={hazmatPermitTypes[type].Name} md={12} className="mb-3">
                            <Card
                                onClick={() => handleOptionChange(hazmatPermitTypes[type].Name)}
                                style={
                                    selectedHazType.type.includes(hazmatPermitTypes[type].Name)
                                        ? { border: 'solid #0074d9 2px' }
                                        : {}
                                }
                            >
                                <Card.Body>
                                    <Card.Subtitle className="mb-2 text-muted">
                                        {hazmatPermitTypes[type].Name} - &#36;
                                        {hazmatPermitTypes[type].Cost}
                                        <p>{hazMatLabel}</p>
                                    </Card.Subtitle>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
			</Container>
			<Container>
				<ControlButtons
					onPrev={onPrevious}
					disableNext={checkFieldsValid()}
					onNext={() => onNext(selectedHazType)}
					onSubmit={hazType => onSubmit(hazType)}
					finalStep={finalStep}
					disablePrev={disablePrev}
				/>
			</Container>
		</>
	);
}
